import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePropertyDocumentByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeletePropertyDocumentByIdMutation = { __typename?: 'mutation_root', delete_property_documents_by_pk?: { __typename?: 'property_documents', id: any } | null };


export const DeletePropertyDocumentByIdDocument = gql`
    mutation deletePropertyDocumentById($id: uuid!) {
  delete_property_documents_by_pk(id: $id) {
    id
  }
}
    `;
export type DeletePropertyDocumentByIdMutationFn = Apollo.MutationFunction<DeletePropertyDocumentByIdMutation, DeletePropertyDocumentByIdMutationVariables>;

/**
 * __useDeletePropertyDocumentByIdMutation__
 *
 * To run a mutation, you first call `useDeletePropertyDocumentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePropertyDocumentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePropertyDocumentByIdMutation, { data, loading, error }] = useDeletePropertyDocumentByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePropertyDocumentByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeletePropertyDocumentByIdMutation, DeletePropertyDocumentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePropertyDocumentByIdMutation, DeletePropertyDocumentByIdMutationVariables>(DeletePropertyDocumentByIdDocument, options);
      }
export type DeletePropertyDocumentByIdMutationHookResult = ReturnType<typeof useDeletePropertyDocumentByIdMutation>;
export type DeletePropertyDocumentByIdMutationResult = Apollo.MutationResult<DeletePropertyDocumentByIdMutation>;
export type DeletePropertyDocumentByIdMutationOptions = Apollo.BaseMutationOptions<DeletePropertyDocumentByIdMutation, DeletePropertyDocumentByIdMutationVariables>;